import { Link } from "react-router";
import site from "../../content/site.json";
import "../portfolio/portfolio.css";

export function MultiDisciplineAbout() {
  return (
    <main className="about-page">
      <header className="work-opening about-opening"><h1>Hi, I'm Mari.</h1><p>Kern County, California</p></header>
      <div className="about-story">
        <div className="about-copy">
          <p className="about-lead">You can book me for weddings, portraits, family sessions, school photography, and events.</p>
          <p className="about-details">The photographs here are from my sports work so far. Tell me what you're planning and we can talk through the details.</p>
          <a href={site.instagram} target="_blank" rel="noopener noreferrer">Message me on Instagram ↗</a>
        </div>
        <figure>
          <img src="/photos/soccer/youngman_soccer_goalkeeper_sunset_00002.jpg" alt="A goalkeeper walking off the field in the evening light" />
          <figcaption><span>From my soccer photographs</span><Link to="/work/sports/soccer">View the series ↗</Link></figcaption>
        </figure>
      </div>
    </main>
  );
}
